import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { routes } from '../../routes'
import { ThreeDots } from '../../common/components/loaders/ThreeDots/ThreeDots'
import styles from './PlayerAccountRedirectLandingPage.module.css'
import { useTranslation } from 'react-i18next'
import { Button } from '../../common/components/button/Button'
import { useTheme } from '../../contexts/ThemeContext'

type PlayerAccountLandingProps = {}

export const PlayerAccountLandingView: React.FC<PlayerAccountLandingProps> = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const { logoUrl } = useTheme()
  const sessionIdParam = searchParams.get('session_id')
  const successParam = searchParams.get('success')
  const msgParam = searchParams.get('msg')

  const [showExpired, setShowExpired] = useState(false)

  useEffect(() => {
    if (successParam)
      if (msgParam === 'OK' && sessionIdParam) {
        localStorage.setItem('sessionKey', sessionIdParam)
        localStorage.setItem('gamer_account_user', sessionIdParam)
        navigate(routes.playerView)
      } else {
        if (msgParam === 'expired') setShowExpired(true)
      }
  }, [msgParam, navigate, sessionIdParam, successParam])

  return showExpired ? (
    <div className={styles.EmptyContent}>
      <div className={styles.seppoLogo}>
        <img width={150} src={logoUrl} alt='logo' onClick={() => navigate(routes.homepage)} />
      </div>
      <h2 className={styles.noGamesHeading}>{t('player_account_view.expired.title', 'Invitation expired!')}</h2>
      <p className={styles.noGamesText}>
        {t('player_account_view.expired.subtitle', 'Invitation is valid for 72 hours.')}
      </p>
      <Button style={{ maxWidth: 'fit-content' }} onClick={() => navigate(routes.login)}>
        {t('player_account_view.expired.button', 'Go to login page')}
      </Button>
    </div>
  ) : (
    <ThreeDots />
  )
}
